import { get, post, put, del } from "../request";

/**
 * 教师实操题库管理
 * /trainAdmin/questionPracticalInfoTeacher
 */
const PRACTICAL = "/trainAdmin/questionPracticalInfoTeacher";

/** 分页查询实操试题列表 */
export function getList(params) {
  return get(`${PRACTICAL}/list`, params);
}

/** 新增实操试题 */
export function createInfo(data) {
  return post(PRACTICAL, data);
}

/** 修改实操试题 */
export function editInfo(data) {
  return put(PRACTICAL, data);
}

/** 删除实操试题 */
export function deleteInfo(id) {
  return del(`${PRACTICAL}/${id}`);
}

/** 查询实操试题详情 */
export function getInfo(id) {
  return get(`${PRACTICAL}/${id}`);
}



// WEBPACK FOOTER //
// ./src/api/questionBank/practical.js